// extracted by mini-css-extract-plugin
export var content = "_e0-3";
export var list = "_e0-4";
export var settingsContent = "_e0-7";
export var settingsPanel = "_e0-8";
export var state = "_e0-6";
export var triggerBadge = "_e0-2";
export var triggerButton = "_e0-1";
export var triggerShell = "_e0-0";
export var unreadDot = "_e0-5";